import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.js';
import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Markdown from "react-markdown";
import FooterLinkList from "../fields/FooterLinkList.js";
import FooterMoreLinks from "../fields/FooterMoreLinks.js"


function Footer({ data }) {
    const scriptRef = useRef();
    const translateRef = useRef();

    useEffect(() => {
        let timeoutId;
        if (translateRef.current && translateRef.current.childNodes.length === 0) {
            function activateTranslate() {
                if (!scriptRef.current) {
                    const addScript = document.createElement('script');
                    addScript.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
                    scriptRef.current = addScript;
                    document.body.appendChild(addScript);
                }

                if (translateRef.current && translateRef.current.childNodes.length === 0 && window.google && window.google.translate) {
                    window.googleTranslateElementInit = new window.google.translate.TranslateElement(
                        {}, 'google-translate'
                    );
                }

                if (translateRef.current && translateRef.current.childNodes.length === 0) {
                    timeoutId = setTimeout(() => {
                        activateTranslate();
                    }, 500);
                }
            }

            activateTranslate();
        }
        return () => {
            clearTimeout(timeoutId);
        }
    }, [scriptRef]);

    return (
        <div key={data.documentId} className="footer">
            <div className="row background-full-width footer-blue footer-div screen-width">

                {/*Footer for non-mobile sizes and now mobile sizes too apparently*/}
                <div className="container-fluid footer-container max-width">
                    <div className="col-sm-12 footer-text no-padding">
                        <div className="row col-sm-3 footer-single-column footer-contact-div">
                            <div style={{paddingBottom:'40px'}}>
                                <img alt="CAP logo"
                                     src={data['logo'].url}
                                     style={{height: '110px', marginTop: '70px'}}/>
                            </div>
                            <div style={{color:'#FFFFFF'}}>
                                <Markdown>{data.contactInformation.replaceAll('\n','  \n')}</Markdown>
                            </div>

                        </div>

                        <div className="row col-sm-7 footer-grid-columns white-text  no-padding">

                            {data.linkLists.map((item, index) => (
                                <div key={ index } className={'footer-main-links'}>
                                    {FooterLinkList({data: item})}
                                </div>
                                ))}

                            {data.moreLinks.map((item, index) => (
                                <div key={ index } className={'footer-main-links'}>
                                    {FooterMoreLinks({data: item})}
                                </div>
                            ))}
                        </div>

                        <div className="row col-sm-2 footer-single-column hotline-div">
                            <div style={{color: '#2ACDC1', paddingBottom: '20px'}}>
                                AIR QUALITY FORECAST HOTLINES
                            </div>
                            <div>
                                <span className="white-text">
                                    <Markdown>{data.forecastHotlines.replaceAll('\n','  \n')}</Markdown>
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="row col-sm-12 white-text bottom-footer-row">
                        <div className="col-sm-8 container legal-links">

                            {/*{regexMatches(data.privacyPolicy)[0]} this is the whole item, 1 is the string, 2 is the url*/}
                            {/*{regexMatches(data.privacyPolicy)[2] string}*/}
                            {/*{regexMatches(data.privacyPolicy)[2] url}*/}

                            <div>
                                <span className="footer-legal-links white-text">
                                  <p><a href={data.privacyLink['url']}>{data.privacyLink['label']}</a></p>
                                </span>
                            </div>

                            <div>
                                <span className="footer-legal-links white-text">
                                  <p><a href={data.termsOfUseLink['url']}>{data.termsOfUseLink['label']}</a></p>
                                </span>
                            </div>

                            <div>
                                <p>{data.copyright}</p>
                            </div>

                            <div ref={translateRef} className="google-translate" id="google-translate"></div>
                        </div>
                    </div>
                </div>

                {/*/!*Footer for mobile sizes*!/*/}
                {/*<div className="container-fluid hidden-sm hidden-md hidden-lg">*/}
                {/*    <div className="footer-text">*/}
                {/*        <div className="row footer-contact-div">*/}
                {/*            <div className="col-xs-4">*/}
                {/*                <img alt="CAP logo"*/}
                {/*                     src="https://cleanairpartners.net/sites/default/files/CAP_Logo_Small_0.svg"*/}
                {/*                     style={{height: '100px'}}/>*/}
                {/*            </div>*/}

                {/*            <div className="col-xs-8" style={{lineHeight: 0.8}}>*/}
                {/*                <p>*/}
                {/*                </p><p><span style={{color:'#FFFFFF'}}>777 North Capitol St.,</span></p>*/}

                {/*                <p><span style={{color:'#FFFFFF'}}>Suite 300</span></p>*/}

                {/*                <p><span style={{color:'#FFFFFF'}}>Washington DC 20002</span></p>*/}

                {/*                <p><span style={{color:'#FFFFFF'}}>Tel: (877) 515-4593</span></p>*/}

                {/*                <p><span style={{color:'#FFFFFF'}}>Fax: (202) 962-3202</span></p>*/}
                {/*                <p></p>*/}
                {/*            </div>*/}
                {/*        </div>*/}

                {/*        <div className="row">*/}

                {/*            <div className="col-xs-6 white-text">*/}
                {/*                <div className="footer-main-link-title">*/}
                {/*                    <strong><a href="https://cleanairpartners.net/about">ABOUT</a></strong>*/}
                {/*                </div>*/}

                {/*                <div className="footer-main-links-mobile">*/}
                {/*                    <a className="white-text"*/}
                {/*                       href="https://cleanairpartners.net/why-air-quality-matters">Why Air Quality*/}
                {/*                        Matters</a>*/}
                {/*                </div>*/}
                {/*                <div className="footer-main-links-mobile">*/}
                {/*                    <a className="white-text" href="https://cleanairpartners.net/how-we-work">How We*/}
                {/*                        Work</a>*/}
                {/*                </div>*/}
                {/*                <div className="footer-main-links-mobile">*/}
                {/*                    <a className="white-text"*/}
                {/*                       href="https://cleanairpartners.net/leadership">Leadership</a>*/}
                {/*                </div>*/}
                {/*                <div className="footer-main-links-mobile">*/}
                {/*                    <a className="white-text" href="https://cleanairpartners.net/contact">Contact</a>*/}
                {/*                </div>*/}

                {/*                <div className="footer-main-link-title">*/}
                {/*                    <strong><a href="https://cleanairpartners.net/air-quality-resources">AIR QUALITY*/}
                {/*                        RESOURCES</a></strong>*/}
                {/*                </div>*/}

                {/*                <div className="footer-main-links-mobile">*/}
                {/*                    <a className="white-text"*/}
                {/*                       href="https://cleanairpartners.net/current-and-forecasted-air-quality">Current*/}
                {/*                        Air Quality</a>*/}
                {/*                </div>*/}
                {/*                <div className="footer-main-links-mobile">*/}
                {/*                    <a className="white-text" href="https://cleanairpartners.net/aqi">Air Quality*/}
                {/*                        Index</a>*/}
                {/*                </div>*/}
                {/*                <div className="footer-main-links-mobile">*/}
                {/*                    <a className="white-text"*/}
                {/*                       href="https://cleanairpartners.net/ozone-particle-pollution">Ozone &amp; Particle*/}
                {/*                        Pollution</a>*/}
                {/*                </div>*/}
                {/*                <div className="footer-main-links-mobile">*/}
                {/*                    <a className="white-text"*/}
                {/*                       href="https://cleanairpartners.net/historical-air-quality">Historical Air*/}
                {/*                        Quality</a>*/}
                {/*                </div>*/}


                {/*            </div>*/}

                {/*            <div className="col-xs-6 hotline-div">*/}
                {/*                <div style={{color: '#2ACDC1'}}>*/}
                {/*                    AIR QUALITY FORECAST HOTLINES*/}
                {/*                </div>*/}
                {/*                <span className="white-text">*/}
                {/*                    <p>NOAA/National Weather Service - Baltimore/Washington Forecast Office</p>*/}
                {/*                    <p>571-888-3500<br/>*/}
                {/*                        select option 1&nbsp;<br/>*/}
                {/*                        then option 7*/}
                {/*                    </p>*/}
                {/*                </span>*/}
                {/*            </div>*/}
                {/*        </div>*/}

                {/*        <div className="row no-wrap more-links-div">*/}
                {/*            <div className="col-xs-6">*/}
                {/*                <div>*/}
                {/*                    <a target="" className="white-text more-footer-link"*/}
                {/*                       href="https://cleanairpartners.net/sponsors">BECOME A SPONSOR</a>*/}
                {/*                </div>*/}
                {/*                <div>*/}
                {/*                    <a target="" className="white-text more-footer-link"*/}
                {/*                       href="https://cleanairpartners.net/event-calendar/month">EVENT CALENDAR</a>*/}
                {/*                </div>*/}
                {/*                <div>*/}
                {/*                    <a target="_blank" className="white-text more-footer-link"*/}
                {/*                       href="http://www.enviroflash.info/">ENVIROFLASH</a>*/}
                {/*                </div>*/}
                {/*                <div>*/}
                {/*                    <a target="" className="white-text more-footer-link"*/}
                {/*                       href="https://cleanairpartners.net/air-quality-resources/#DownloadtheAirQualityApp">APP*/}
                {/*                        DOWNLOADS</a>*/}
                {/*                </div>*/}
                {/*            </div>*/}

                {/*            <div className="col-xs-6" id="mobile_translate">*/}
                {/*            </div>*/}
                {/*        </div>*/}


                {/*    </div>*/}

                {/*    <div className="white-text bottom-footer-row">*/}
                {/*        <div className="legal-links">*/}
                {/*            <div>*/}
                {/*                <span className="footer-legal-links white-text">*/}
                {/*                    <p><a href="https://cleanairpartners.net/privacy-policy">Privacy Policy</a></p>*/}
                {/*                </span>*/}
                {/*            </div>*/}

                {/*            <div>*/}
                {/*                <span className="footer-legal-links white-text">*/}
                {/*                    <p><a href="https://cleanairpartners.net/terms-of-use">Terms of Use</a></p>*/}
                {/*                </span>*/}
                {/*            </div>*/}

                {/*            <div>*/}
                {/*                <p>© 2017 Clean Air Partners</p>*/}
                {/*            </div>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}
            </div>
        </div>
    );
}

export default Footer;
